<template>
  <div class="signProtocol-list">
    <div class="topInfo">
      <div>
        <el-button class="addProtocol" type="primary" @click="handlerAdd">新增协议</el-button>
      </div>
    </div>
    <ab-list-query
      :class="{ 'wait': activeName !== 'signed' }"
      :tabs="tabs"
      style="margin-top: 4px"
      :isActive="activeName"
      @handleTabs="handleTabs"
      :showToolbar="false"
    >
      <template #right v-if="activeName == 'signed'">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              size="mini"
              placeholder="协议名称/主协议编码"
              v-model.trim="formSearch.numberOrPaperNum"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <ab-select
              data-type="table"
              placeholder="业务类型"
              url="/bas/client/servProtocol/bizTypeList"
              v-model="formSearch.typeDesc"
              cueString="业务类型"
              :tab-tag-data="[
                { label: '编码', prop: 'number' },
                { label: '名称', prop: 'name' },
                { label: '业务类别', prop: 'serviceTypeDesc' },
              ]"
              @changeData="typeSelect"
            ></ab-select>
          </el-col>
          <el-col :span="4">
            <el-select
              size="mini"
              v-model="formSearch.dateType"
              @change="searchForm1({ currentPage: 1 })"
              placeholder="生效日期"
            >
              <el-option label="生效日期" :value="0"></el-option>
              <el-option label="签约日期" :value="1"></el-option>
              <el-option label="创建日期" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="业务日期起"
              endSrc="业务日期止"
              :disabled="!formSearch.dateType && formSearch.dateType !== 0"
              @searchEvent="dateChange"
            ></ab-timeSearch>
          </el-col>
          <el-col :span="4" class="text-left">
            <el-button @click="init">搜索</el-button>
            <el-button link class="btn-svg" @click="resetForm"
              ><ab-svg name="qingchu"></ab-svg>清除</el-button
            >
          </el-col>
        </el-row>
      </template>
      <template #table>
        <ab-table
          class="addressTable toSign"
          ref="table"
          v-if="activeName == 'toSign'"
          key="toSign"
          showOrder
          stripe
          showEdit
          index-label="序号"
          index-width="55"
          widths="200"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="isloading"
          isFilter='operator'
          @filterColumns="filterColumns"
        >
          <template #operator="scope">
            <div class="other">
              <el-button
                type="text"
                @click="handlerEdit(scope.row)"
                >签署</el-button
              >
              <el-button
                type="text"
                @click="handlerDelete(scope.row.id)"
                style="margin-left: 10px"
                class="redBtn"
                >删除</el-button
              >
            </div>
          </template>
        </ab-table>

        <ab-table
          v-if="activeName == 'signed'"
          key="signed"
          class="addressTable"
          ref="table"
          stripe
          index-label="序号"
          index-width="55"
          widths="200"
          showEdit
          :column-list="columns1"
          :table-list="tableData1"
          :sortChange="sortChange"
          :dataListLoading="btns.table"
          :handleSelectionChange="tableSelect"
          :row-class-name="tableRowClassName"
            isFilter='operator'
            @filterColumns="filterColumns1"
        >
          <template #operator="scope">
            <div class="operator">
              <el-button
                type="text"
                style="
                  float: left;
                  font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
                  font-weight: 400;
                  color: #0b7aff;
                "
                class="is-link"
                v-if="scope.row.haveFile"
                @click="downLoadFile(scope.row)"
                >下载协议</el-button
              >
              <!-- <div
                style="
                  float: left;
                  width: 1px;
                  height: 9px;
                  background-color: #e5e5e5;
                  margin: 3px 5px 2px;
                "
                class="is-link"
              ></div> -->
              <el-button
                type="text"
                :style="{
                    'margin-left': '10px',
                    float: 'left',
                    'font-weight': '400',
                }"
                :class="{redBtn: scope.row.isEnable}"
                class="is-link"
                :loading="isEnableLoading"
                @click="switchEnable(scope.row)"
                >{{ scope.row.isEnable ? "禁用" : "启用" }}</el-button
              >
            </div>
          </template>
          <template #createTime="scope">{{scope.row.createTime ? 
            $filters.formatterTime(scope.row.createTime) : ''
          }}</template>

          <!-- <template #isdownload="scope">
                <div @click="downLoadFile(scope.row)" v-if="scope.row.haveFile">
                    <icon-svg name="attachment" class="table-uplaod-icon"></icon-svg>
                </div>
                </template> -->

          <!-- <template #isEnable="scope">
                <el-switch
                    v-model="scope.row.isEnable"
                    @change="switchEnable(scope.row)"
                    :active-value="1"
                    :inactive-value="0"
                ></el-switch>
                </template> -->

          <template #businessManIdDesc="prop">
            <el-button
              v-if="$isAuth('cust:agreement:service:busMan')"
              type="text"
              @click="resetEmployee(prop.row.id, '商务员', 'businessManId')"
              >{{ prop.row.businessManIdDesc }}</el-button
            >
            <span v-else>{{ prop.row.businessManIdDesc }}</span>
          </template>

          <template #regulatoryName="prop">
            <el-button
              v-if="$isAuth('cust:agreement:service:regul')"
              type="text"
              @click="resetEmployee(prop.row.id, '财务核管', 'regulatoryId')"
              >{{ prop.row.regulatoryName }}</el-button
            >
            <span v-else>{{ prop.row.regulatoryName }}</span>
          </template>

          <template #riskControlName="prop">
            <el-button
              v-if="$isAuth('cust:agreement:service:risk')"
              type="text"
              @click="resetEmployee(prop.row.id, '风控', 'riskControlId')"
              >{{ prop.row.riskControlName }}</el-button
            >
            <span v-else>{{ prop.row.riskControlName }}</span>
          </template>

          <template #isAutoSettle="scope">
            <el-switch
              v-if="!['境内代采', '境外代采'].includes(scope.row.typeDesc)"
              :disabled="!$isAuth('cust:agreement:service:autoSettle')"
              v-model="scope.row.isAutoSettle"
              @change="switchAutoSettle(scope.row)"
            ></el-switch>
          </template>
          <template #isAutoWriteOff="scope">
            <el-switch
              :disabled="
                !$isAuth('cust:agreement:service:autoWrite') ||
                ['03', '04', '06'].includes(scope.row.type)
              "
              v-model="scope.row.isAutoWriteOff"
              @change="switchAutoWrite(scope.row)"
            ></el-switch>
          </template>
        </ab-table>
      </template>
      <template #page>
        <ab-page
          ref="pagination"
          :pageTotal="total"
          v-if="activeName == 'signed'"
          @searchForm="searchForm1"
        ></ab-page>
        <ab-page
          v-if="activeName == 'toSign'"
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>

    <el-dialog
      title="请选择签署的的业务类型"
      v-model="show"
      width="400px"
      custom-class="home-dialog"
      :show-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="sel-g-t">
        <el-button type="primary" v-if="isImport" @click="goRatifySealData"
          >进口</el-button
        >
        <el-button type="primary" v-if="isExport" @click="goApproveExport"
          >出口</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请选择用途"
      @close="signType = ''"
      v-model="signShow"
      width="475px"
      custom-class="organizer-dialog"
      :show-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
        <div>
            <div class="org-item" @click="checkedOrganizer(obj)" :class="{'isActived': signType == obj.value}" v-for="(obj, idx) in             !(
              bizTypeList.includes('01') &&
              bizTypeList.includes('02') &&
              bizTypeList.includes('04')
            ) ? [{value: '01', desc: '增加业务类型'}, {value: '02', desc: '新签一家企业'}] : [{value: '02', desc: '新签一家企业'}]" :key="idx">
                <div class="org-tel">
                    <el-icon><ArrowDownBold /></el-icon>
                </div>
                <div class="">{{obj.desc}}</div>
            </div>
        </div>
        <template #footer class="dialog-footer">
          <el-button type="primary" :disabled="!signType" @click="checkedSign"
            >确定</el-button
          >
          <el-button @click="signShow = false">取消</el-button>
        </template>
    </el-dialog>
    <ab-preview :preview="preview" @handleClose="handleClose">
      <template #button>
        <el-button @click="preview.show = false">关 闭</el-button>
      </template>
    </ab-preview>
    <employeeDialog
      :id="employeeDialog.id"
      :role="employeeDialog.role"
      :roleId="employeeDialog.roleId"
      v-model="employeeDialog.show"
      @init="localSearch"
    ></employeeDialog>
    <ab-downloadFile :dialog="uploadParams"></ab-downloadFile>
  </div>
</template>

<script>
import employeeDialog from "../cooperation-agreement/employeeDialog.vue";
export default {
  name: "signProtocol-list", // 服务协议列表
  components: {
    employeeDialog,
  },
  data() {
    return {
      signShow: false,
      signType: "",
      bizTypeList: [],
      tabs: [
        { name: "待签署", value: '', state: "toSign" },
        { name: "已签署", value: '', state: "signed" },
      ],
      isEnableLoading: false,
      showMore: true,
      activeName: "toSign",
      show: false, // 选择签署协议类型弹框
      columns: [
        {
          labels: "主协议号",
          props: "paperNumber",
          widths: 200,
        },
        {
          labels: "操作时间",
          props: "updateTime",
          widths: 200,
        },
        {
          labels: "操作人",
          props: "updateByName",
          widths: 200,
        },
      ],
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0,
      },
      tableData: [],
      isloading: false,
      isImport: false,
      isExport: false,
      preview: {
        show: false,
        isView: false,
        isFooter: true,
        fileUrl: "",
      },
      btns: {
        delete: false,
        download: false,
        export: false,
        table: false,
      },
      order: undefined, // 排序方向
      sortName: undefined, // 排序规则
      multipleSelection: [], // 表格勾选行

      fileDialog: {
        show: false,
      },

      total: 0,

      // 查询参数
      formSearch: {
        dateType: 0,
      },
      formSearch1: {},

      // 表格参数
      tableData1: [],
      columns1: [
        //   {
        //     props: 'isdownload',
        //     labels: '附件',
        //     widths: 50,
        //     align: 'center',
        //     slot: 'slot'
        //   },
        {
          props: "paperNumber",
          labels: "主协议编号",
          widths: 200,
        },

        {
          props: "contractDate",
          labels: "签约日期",
          sort: true,
          widths: 110,
        },
        {
          props: "validDate",
          labels: "生效日期",
          sort: true,
          widths: 110,
        },
        {
          props: "invalidDate",
          labels: "失效日期",
          sort: true,
          widths: 110,
        },
        {
          props: "createTime",
          labels: "创建日期",
          widths: 100,
          slot: "slot",
        },
        {
          props: "name",
          labels: "协议名称",
          sort: true,
          widths: 370,
        },
        {
          props: "typeDesc",
          labels: "业务类型",
          sort: true,
          widths: 80,
        },

        //   {
        //     props: 'isEnable',
        //     labels: '启用状态',
        //     slot: 'slot',
        //     widths: 70,
        //   },

        // {
        //   props: '',
        //   labels: '当前审批节点',
        //   widths: 100,
        // },
        // {
        //   props: '',
        //   labels: '审批结果',
        //   widths: 100,
        // },
        {
          props: "principalName",
          labels: "甲方(委托方)",
          sort: true,
          widths: 250,
        },
        {
          props: "trusteeName",
          labels: "乙方(受托方)",
          sort: true,
          widths: 250,
        },
        {
          props: "businessManIdDesc",
          labels: "商务",
          widths: 80,
          slot: "slot",
        },
      ],

      employeeDialog: {
        role: "",
        id: "",
        show: false,
      },
      uploadParams: {
        sourceBillId: "",
        sourceBillNumber: "",
        sourceBillType: "ServProtocol",
        show: false,
        title: "协议下载",
        items: [
          {
            required: true,
            title: "合作协议",
            attachType: "010",
          },
        ],
      },
    };
  },
  created() {
    let time = new Date();
    let day = ("0" + time.getDate()).slice(-2);
    let month = ("0" + (time.getMonth() + 1)).slice(-2);
    let queryDate = time.getFullYear() + "-" + month + "-" + day;
    this.$post("/bas/servProtocol/list", {
      currentPage: 1,
      dateType: 0,
      pageNum: 1,
      pageSize: 10,
      queryDate,
      typeList: ["01", "02", "03", "04", "06", "07", "08"],
    }).then(({ data }) => {
      if (data && data.code === "C0000") {
        let arry = [];
        if (data.result && data.result.list.length) {
          data.result.list.map((e) => {
            arry.push(e.type);
          });
          arry = Array.from(new Set(arry));
          this.bizTypeList = arry;
        }
        // this.tabs[1].value = data.result.total
        if (!arry.includes("01") && !arry.includes("02")) {
          this.isImport = true;
        }
        if (!arry.includes("04")) {
          this.isExport = true;
        }
      }
    });
    
  },
  activated () {
    this.searchForm1({ currentPage: 1, pageSize: 10 });
    // this.init();
    if(this.$route.query.activeName) {
      this.handleTabs(this.$route.query.activeName)
    }else {
      this.init();
    }
  },
  computed: {
    deleteBtn() {
      if (this.multipleSelection.length !== 1) {
        return true;
      } else {
        const row = this.multipleSelection[0];
        return row.statusDesc === "已审核";
      }
    },
  },
  methods: {
    filterColumns1(array) {
      this.columns1 = array;
    },
    filterColumns(array) {
      this.columns = array;
    },
    checkedOrganizer(obj) {
      this.signType = obj.value
    },
    gotoSign(signType, confirm) {
      this.$router.push({
        path: signType == "01" ? "/agreemant-renewal" : "new-sign",
        query: {
          confirm,
        },
      });
    },
    checkedSign() {
      this.gotoSign(this.signType, true);
      this.signShow = false;
    },
    handleTabs(item) {
        console.log(item);
      this.activeName = item;
      this.init();
    },
    init() {
      if (this.activeName == "toSign") {
        this.getListData();
      } else {
        this.localSearch(1);
      }
    },
    changeCheckedTab(type) {
      if (type) {
        this.activeName = type;
        this.page.pageSize = 10;
        this.page.currentPage = 1;
        this.formSearch = {};
        this.formSearch1 = {};
      }
      if (this.activeName == "toSign") {
        this.getListData();
      } else {
        this.localSearch(1);
      }
    },
    //   entrustSelect(value) {
    //     // 选择委托方
    //     this.$set(this.formSearch, 'entrustIdDesc', value)
    //   },
    typeSelect(val) {
      // 选择业务类型
      if (val) {
        this.formSearch.type = val.number;
      } else {
        this.formSearch.type = "";
      }
      this.searchForm1({ currentPage: 1 });
    },
    //   queryPersonNameSelect(name) {
    //     // 选择角色
    //     this.$set(this.formSearch, 'queryPersonName', name)
    //   },
    localSearch(page) {
      this.$nextTick(() => {
        this.$refs.pagination.currentChange(page);
      });
    },
    dateChange(dateRange) {
      if (dateRange && dateRange.length) {
        switch (this.formSearch.dateType) {
          case 0:
            this.formSearch.startValidDate = dateRange[0];
            this.formSearch.endValidDate = dateRange[1];
            break;
          case 1:
            this.formSearch.startContractDate = dateRange[0];
            this.formSearch.endContractDate = dateRange[1];
            break;
          case 2:
            this.formSearch.startCreateDate = dateRange[0];
            this.formSearch.endCreateDate = dateRange[1];
            break;
        }
      }else{
            this.formSearch.startValidDate = ''
            this.formSearch.endValidDate = ''
            this.formSearch.startContractDate = ''
            this.formSearch.endContractDate = ''
            this.formSearch.startCreateDate = ''
            this.formSearch.endCreateDate = ''
      }
      this.searchForm1({ currentPage: 1 })
    },
    searchForm1(data) {
      // 查询
      data.pageNum = data.currentPage;
      Object.assign(data, this.formSearch);
      data.sortName = this.sortName;
      data.order = this.order;
      data.data = { numberOrPaperNum: this.formSearch.numberOrPaperNum };
      data.typeList = ["01", "02", "03", "04", "06", "07", "08"];
      this.btns.table = true;
      this.$post("/bas/servProtocol/list", data)
        .then((res) => {
          if (res.data && res.data.code === "C0000") {
            this.tableData1 = res.data.result.list;
            this.total = res.data.result.total;
          } else {
            this.$message.error(res.data.message);
            this.tableData1 = [];
            this.total = 0;
          }
        })
        .finally(() => {
          this.btns.table = false;
        });
    },
    resetForm() {
      // 重置
      this.formSearch = {
        dateType: 0,
      };
      this.dateRange = [];
    },
    tableSelect(val) {
      // 选中的tableList
      this.multipleSelection = val;
    },
    newPage() {
      // 跳转至服务协议新增
      this.$router.push({
        path: "/cooperation-agreement/detail",
        query: {
          action: "add",
          cache: "0",
        },
      });
    },
    // 复制创建
    copyPage() {
      this.$router.push({
        path: "/cooperation-agreement/detail",
        query: {
          action: "copy",
          cache: "0",
          id: this.multipleSelection[0].id,
        },
      });
    },
    deleteItem() {
      // 删除条目
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const id = this.multipleSelection[0].id;
        this.btns.delete = true;
        this.$post("/bas/servProtocol/del", { id })
          .then((res) => {
            if (res.data && res.data.code === "C0000") {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.localSearch();
            }
          })
          .finally(() => {
            setTimeout(() => {
              this.btns.delete = false;
            }, 200);
          });
      });
    },
    sortChange(column) {
      // 排序
      let prop = "";
      switch (column.prop) {
        case "typeDesc":
          prop = "s.type";
          break;
        case "statusDesc":
          prop = "s.status";
          break;
        case "principalName":
          prop = "s.entrust_id";
          break;
        case "trusteeName":
          prop = "s.trustee_id";
          break;
        case "contractDate":
          prop = "s.contract_date";
          break;
        case "validDate":
          prop = "s.valid_date";
          break;
        case "invalidDate":
          prop = "s.invalid_date";
          break;
        default:
          prop = column.prop ? "s." + column.prop : undefined;
          break;
      }
      this.order = column.order ? column.order.split("ending")[0] : undefined;
      this.sortName = prop;
      this.localSearch();
    },
    showDetail(row) {
      // 跳转至服务协议详情
      this.$router.push({
        path: "/cooperation-agreement/detail",
        query: {
          action: "detail",
          id: row.id,
          cache: "0",
        },
      });
    },
    //   // 下载
    //   downloadFile() {
    //     this.btns.download = true
    //     let url =
    //       'https://scp-static.cicsc.com/prod/template/%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE%E6%89%B9%E5%AF%BC%E6%A8%A1%E6%9D%BF.xlsx'
    //     // 创建隐藏的可下载链接
    //     var eleLink = document.createElement('a')
    //     eleLink.download = ''
    //     eleLink.style.display = 'none'
    //     // 字符内容转变成blob地址
    //     eleLink.href = url
    //     // 触发点击
    //     document.body.appendChild(eleLink)
    //     eleLink.click()
    //     // 然后移除
    //     document.body.removeChild(eleLink)
    //     this.btns.download = false
    //   },
    // 导出
    exportFile() {
      this.btns.export = true;
      let excelField = this.columns.map((e) => {
        return e.props;
      });
      let data = Object.assign({}, this.formSearch);
      this.$post("/bas/servProtocol/exportList", { data, excelField })
        .then((res) => {
          if (res.data.code == "C0000") {
            this.$message({
              type: "success",
              message: res.data.message,
            });
          }
        })
        .finally((e) => {
          setTimeout((e) => {
            this.btns.export = false;
          }, 200);
        });
    },      
    switchEnable(row) {
        // 切换启/禁用状态      
        this.$prompt("", "请输入变更原因", {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "变更原因",
        inputValidator: value => {
          if (value) {
            return value.length <= 200;
          }
          return false;
        },
        inputErrorMessage: "请输入原因，限200字"
      }).then(({value}) => {
        this.isEnableLoading = true;
        this.$get('/bas/servProtocol/enable', {
          id: row.id,
          isEnable: row.isEnable,
          protocolChangeReason: value
        })
          .then((res) => {
            if (res.data && res.data.code === 'C0000') {
              this.$message.success(res.data.message)
            }
          })
          .finally(() => {
            this.isEnableLoading = false;
            this.localSearch()
          })
        }).catch(( ) => {
            this.localSearch()
        })
      },
    // 切换启用状态
    switchAutoSettle(row) {
      this.$get("/bas/servProtocol/autoSettle", {
        id: row.id,
        isAutoSettle: row.isAutoSettle,
      })
        .then((res) => {
          if (res.data && res.data.code === "C0000") {
            this.$message.success(res.data.message);
          }
        })
        .finally(() => {
          this.localSearch();
        });
    },
    // 切换启用状态
    switchAutoWrite(row) {
      this.$get("/bas/servProtocol/setAutoWriteOff", {
        id: row.id,
        isAutoWriteOff: row.isAutoWriteOff,
      })
        .then((res) => {
          if (res.data && res.data.code === "C0000") {
            this.$message.success(res.data.message);
          }
        })
        .finally(() => {
          this.localSearch();
        });
    },
    resetEmployee(id, role, roleId) {
      this.employeeDialog.id = id;
      this.employeeDialog.role = role;
      this.employeeDialog.roleId = roleId;
      this.employeeDialog.show = true;
    },

    // 倒计时区间的协议
    tableRowClassName({ row, rowIndex }) {
      if (row.isExpiring) {
        return "danger-row";
      }

      return "";
    },
    downLoadFile(row) {
      this.uploadParams.sourceBillId = row.id;
      this.uploadParams.show = true;
    },
    searchForm() {
      this.page.currentPage = 1;
      this.getListData();
    },
    getListData() {
      let data = Object.assign(
        { data: this.formSearch1},
        { pageNum: this.page.currentPage, pageSize: this.page.pageSize }
      );
      this.$post("/crm/client/signProtocol/list", data, this, "isloading").then(
        (res) => {
          if (res.data.code == "C0000") {
            this.tableData = res.data.result.list;
            this.page.total = res.data.result.total;
            if(res.data.extra) {
              if (res.data.extra.toSign) {
                this.tabs[0].value = res.data.extra && Number(res.data.extra.toSign) || ''
              }
                // this.tabs[1].value = res.data.extra.signed
             /*  this.tabs.forEach(e=>{
                e.value = res.data.extra[e.state] || ''
              }) */
            }
            // this.tabs[0].value = res.data.result.total
          }
        }
      );
    },
    pageSearch(obj) {
      this.page.currentPage = obj.currentPage;
      this.page.pageSize = obj.pageSize;
      this.getListData();
    },
    handlerAdd() {
      this.$post("/crm/clientSignStep/createNewPro").then(({ data }) => {
        if (data && data.code == "C0000") {
          if (
            !data.result ||
            !data.result.personCertified ||
            !data.result.organizationCertified
          ) {
            this.$message.error("请先完成个人认证和企业认证！");
            this.$router.push({ path: "/my-signature" });
            return;
          }
          this.signShow = true;
        } else {
          this.$message.error("请先完成个人认证和企业认证！");
          return;
        }
      });
    },
    goRatifySealData() {
      this.show = false;
      this.$router.push({
        path: "/user-center/signProtocol-details",
        query: {
          action: "detail",
          status: "add",
          cache: false,
          backUrl: "/user-center-signProtocol-list",
          type: "01",
        },
      });
    },
    goApproveExport() {
      this.show = false;
      this.$router.push({
        path: "/user-center/export-details",
        query: {
          action: "detail",
          status: "add",
          cache: false,
          backUrl: "/user-center-signProtocol-list",
          type: "02",
        },
      });
    },
    handlerEdit(row) {
      this.$get("/sys/esignTask/getFlowUrl", {
        id: row.esignTaskId,
        flowId: row.flowId,
        urlType: 0,
      })
        .then(({ data }) => {
          if (data.code === "C0000") {
            this.preview.isView = true;
            this.preview.fileTitle = row.esignBillTypeDesc;
            this.preview.fileUrl = data.result;
            this.preview.show = true;
          }
        })
        .finally(() => {
          this.searchForm();
        });

      // let id = row.id
      // let type = row.bizTypeGroup
      // let path = type == '02'? '/user-center/export-details' : 'user-center/signProtocol-details'
      // this.$router.push({
      //     path,
      //     query: {
      //         action: "detail",
      //         status: 'edit',
      //         id,
      //         cache: false,
      //         backUrl: '/user-center-signProtocol-list',
      //         type
      //     }
      // })
    },
    handlerDelete(id) {
      this.$post(
        "/crm/client/signProtocol/del",
        { id: id },
        this,
        "isloading"
      ).then(({ data }) => {
        if (data && data.code === "C0000") {
          this.getListData();
        }
      });
    },
    handleClose() {
      this.searchForm();
    }
  },
};
</script>

<style lang="scss">
.sign-dialog {
  .el-dialog__body {
    min-height: 0px;
    .sign-type {
      .el-radio {
        margin-left: 85px;
        margin-bottom: 10px;
        line-height: 30px;
        display: block;
        .el-radio__input {
          .el-radio__inner {
            width: 20px;
            height: 20px;
            &::after {
              width: 10px;
              height: 10px;
            }
          }
        }
        .el-radio__label {
          position: relative;
          font-size: 18px;
          top: 2px;
          font-weight: bold;
        }
      }
    }
  }
}
.home-dialog {
  .sel-g-t {
    button {
      width: 90%;
      margin-top: 40px;
      line-height: 2;
      font-size: 14px;
      font-weight: 600;
    }
    .el-button + .el-button {
      margin-left: 0px;
    }
    .el-button--primary {
      background-color: rgba(0, 140, 231, 1);
      border-color: rgba(0, 140, 231, 1);
    }
    text-align: center;
  }
  .sel-g-user {
    margin-top: 50px;
  }
}
.signProtocol-list {
  .topInfo {
    height: 148px;
    padding: 20px 20px 0;
    width: 100%;
    display: table;
    &>div{
        height: 100%;
        width: 100%;
        background-image: url("../../assets/img/protocol-bgd.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        .addProtocol {
            position: absolute;
            top: 42px;
            right: 421px;
        }
    }
  }

  .filter {
    margin-bottom: 10px;
    background-color: #fff;
    .tabTop,
    .filterItem {
      width: 100%;
      height: 60px;
      .el-form-item {
        width: 200px;
        float: left;
        margin-left: 30px;
        margin-top: 15px;
      }
      .el-form-item:nth-child(3) {
        width: 283px;
      }
    }
    .tabTop {
      font-size: 14px;
      font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      .tabItem {
        height: 60px;
        padding: 0 22px;
        line-height: 60px;
        float: left;
        cursor: pointer;
        span {
          color: #ff4040;
        }
      }
      .isCheckedTab {
        position: relative;
        color: #0b7aff;
        &::after {
          content: "";
          width: 100px;
          height: 2px;
          background-color: #0b7aff;
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -50px;
        }
      }
      .tabItem:nth-child(1) {
        margin-left: 8px;
      }
      .search {
        float: right;
        width: 400px;
        height: 30px;
        margin-top: 15px;
        .el-input {
          width: 360px;
          float: left;
          height: 30px;
          .el-input__inner {
            height: 30px;
          }
        }
        .magnifier {
          float: right;
          width: 40px;
          height: 30px;
          background-color: #4c93f8;
          padding: 6px 0 0 12px;
          cursor: pointer;
          .icon-svg {
            color: #fff;
            width: 18px;
            height: 18px;
            text-align: center;
          }
        }
      }
      .more {
        float: right;
        width: 60px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #e5e5e5;
        line-height: 30px;
        font-size: 14px;
        font-family:  PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
        font-weight: 400;
        color: #162232;
        text-indent: 9px;
        margin-top: 15px;
        margin: 15px 30px;
        cursor: pointer;
        position: relative;
        &:hover {
          opacity: 0.8;
        }
        .icon-svg {
          color: #7e858f;
          position: absolute;
          right: 5px;
          top: 10px;
          height: 10px;
          width: 14px;
          text-align: center;
        }
      }
      .unfold {
        .icon-svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  .content {
    background: #fff;

    // .addressTable {
    //   margin-top: 6px;
    //   .operator {
    //     font-size: 0;
    //     display: flex;
    //   }

    //   .el-button--text {
    //     padding: 0;
    //   }
    // }
  }
    .other{
        button{
            min-width: 0;
            padding: 0 !important;
            height: 23px;
        }
    }
    .ab-list-query.wait {
        .query-list {
            margin-top: 0 !important;
        }
    }
}
</style>
